import { z } from 'zod';

/**
 * Só valida formato — nunca se o e-mail está cadastrado. Essa checagem é do
 * servidor, e a resposta é sempre a mesma frase (regra 6 / ADR-002 / US-02),
 * então não há "e-mail não encontrado" para o Zod expressar aqui.
 */
export const loginSchema = z.object({
  email: z
    .string()
    .trim()
    .min(1, 'Informe seu e-mail.')
    .email('Digite um e-mail válido.')
    .transform((value) => value.toLowerCase()),
});

export type LoginFormValues = z.infer<typeof loginSchema>;

/** Código de 6 dígitos enviado por e-mail (`supabase/templates/magic_link.html`). */
export const otpSchema = z.object({
  token: z
    .string()
    .trim()
    .length(6, 'O código tem 6 dígitos.')
    .regex(/^\d{6}$/, 'Use apenas números.'),
});

export type OtpFormValues = z.infer<typeof otpSchema>;
